<template>
  <div>
    <div class="containerBackgroundTable bg-primary">
      <div class="ml-5 mr-5 pt-4 d-flex flex-column">
        <div class="d-flex align-content-start flex-wrap">
          <h2 class="ml-8 mr-2 mb-5 white--text">Instancias</h2>
        </div>
        <div
          class="d-flex align-content-start flex-wrap"
          style="margin-right: 20px;"
        >
          <div class="ml-4 mr-2" style="width: 100%;">
            <v-toolbar class="pl-0" flat color="transparent">
              <v-row justify="start">
                <v-col lg="4">
                  <v-text-field
                    v-model="search"
                    solo
                    prepend-inner-icon="mdi-magnify"
                    color="black"
                    label="Buscar"
                    class="searchWidth mt-4"
                  >
                    <v-icon dark>mdi-face-agent</v-icon>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-btn class="button-gray" @click="isActiveModal = true"
                >Escalar</v-btn
              >
            </v-toolbar>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <rtpEngineTable
        class="ml-5 mr-5 mt-6"
        :search="search"
        :listRtpEngine="listRtpEngine"
      />
    </div>
    <div>
      <rtpEngineModal
        class="ml-5 mr-5"
        :isActiveModal="isActiveModal"
        :instances="listRtpEngine"
        @close="isActiveModal = false"
      />
    </div>
  </div>
</template>

<script>
import rtpEngineTable from "../../components/rtp-engine/rtpEngineTable";
import rtpEngineModal from "../../components/rtp-engine/rtpModal"; //Modal donde se seleccionara la etiqueta o el bucket del usuario.
import { mapGetters } from "vuex";

export default {
  data: () => ({
    search: "",
    refresh: null,
    isActiveModal: false,
  }),
  components: {
    rtpEngineTable,
    rtpEngineModal,
  },
  methods: {
    refresTablet() {
      this.$store.dispatch("rtpEngine/getAllRtpEngine");
    },
  },
  mounted() {
    const timeOut = 10000;
    this.refresh = setInterval(() => {
      this.refresTablet();
    }, timeOut);
  },
  computed: {
    ...mapGetters("rtpEngine", { listRtpEngine: "RtpEngineTable" }), // Traemos los valores
  },
  created() {
    this.$store.dispatch("rtpEngine/getAllRtpEngine");
  },
  beforeDestroy() {
    clearInterval(this.refresh);
  },
};
</script>
